let arr=[
    {name:'未配置类型',value:'未配置类型'},
    {name:'抽样任务',value:'抽样任务'},
    {name:'抽样检测任务',value:'抽样检测任务'}
]
export default arr